import { render, staticRenderFns } from "./PersonEnterContent.vue?vue&type=template&id=2a75e8d6&scoped=true"
import script from "./PersonEnterContent.vue?vue&type=script&lang=js"
export * from "./PersonEnterContent.vue?vue&type=script&lang=js"
import style0 from "./PersonEnterContent.vue?vue&type=style&index=0&id=2a75e8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a75e8d6",
  null
  
)

export default component.exports